import slideout from "../helpers/slideout";
import { getParameterByName, debounce, isDesktop } from "../helpers/utilities";
import accordion from './accordion';

interface IFiltersConfig {
  slideouts: any[],
  selectors: IFiltersSelectors,
  classNames: IFiltersClassNames,
  isDesktop: boolean,
  dropdown: any,
  options: NodeList,
  openBtn: NodeList
}

interface IFiltersSelectors {
  main: string,
  open: string,
  close: string,
  dropdown: string,
  sortBy: string,
  mobile: string,
  desktop: string,
  option: string
}

interface IFiltersClassNames {
  open: string,
  hide: string
}

class Filters {

  private config: IFiltersConfig;

  constructor() {
    this.config = {
      slideouts: [],
      isDesktop: null,
      dropdown: null,
      options: null,
      openBtn: null,
      selectors: {
        main: '[data-filters]',
        mobile: '[data-filters="mobile"]',
        desktop: '[data-filters="desktop"]',
        dropdown: '[data-filters-dropdown]',
        open: '[data-filters-open-btn]',
        close: '[data-filters-close-btn]',
        sortBy: '[data-sort-by-toggle]',
        option: '[data-filters-option]'
      },
      classNames: {
        open: 'filters--open',
        hide: 'hide'
      }
    }
  }

  public init() {
    if (!window.location.pathname.includes('collection')) return;

    document.querySelectorAll(this.config.selectors.main).forEach((htmlElement: HTMLElement) => {
      this.load(htmlElement);
    });

    document.querySelectorAll(this.config.selectors.open).forEach((filterBtn => {
      filterBtn.addEventListener('click', this.handleOpenClick.bind(this));
    }));

    document.querySelectorAll(this.config.selectors.close).forEach((filterBtn => {
      filterBtn.addEventListener('click', this.handleCloseClick.bind(this));
    }));

    document.querySelectorAll(this.config.selectors.sortBy).forEach((sortByBtn => {
      sortByBtn.addEventListener('click', this.handleCloseClick.bind(this));
    }));
  }

  private load(node:HTMLElement) {
    this.config.isDesktop = isDesktop();

    if (this.config.isDesktop) {
      this.config.slideouts.forEach(_slideout => slideout.destroy(_slideout));
      this.config.slideouts = [];
      this.config.dropdown = document.querySelector(this.config.selectors.desktop);
    } else {
      this.config.slideouts.push(slideout.init(node)); 
      this.updateSortBy();
    }
  }

  private openDropdown(event: Event) {
    const target = event.target as HTMLElement;
    const open = target.closest(this.config.selectors.open);

    if (!open.classList.contains(this.config.classNames.open)) {
      const sortBy = document.querySelector('[data-sort-by-toggle]');
      this.config.dropdown.classList.add(this.config.classNames.open);
      open.classList.add(this.config.classNames.open);
      sortBy.classList.remove('accordion--active');
      accordion.load();
      return;
    }

    this.closeDropdown();
  }

  private closeDropdown() {
    this.config.dropdown.classList.remove(this.config.classNames.open);
    document.querySelectorAll(this.config.selectors.open).forEach(htmlElement => htmlElement.classList.remove(this.config.classNames.open));
  }

  private updateSortBy() {
    const currentSortBy = getParameterByName('sort_by');
    const sortBy = document.querySelector(`[data-sort-by="${ currentSortBy }"]`);
    let accordion = null;
    if (sortBy) accordion = sortBy.closest('[data-accordion]'), sortBy.classList.add('selected');
    if (accordion) accordion.classList.add('accordion--active');
  }

  private handleOpenClick(event:Event) {
    event.preventDefault();
    this.open(event);
  }

  private handleCloseClick(event:Event) {
    event.preventDefault();
    this.close();
  }

  public reinit = debounce(() => {
    if (!window.location.pathname.includes('collection')) return;
    document.querySelectorAll(this.config.selectors.main).forEach((htmlElement: HTMLElement) => {
      this.close();
      this.load(htmlElement);
    });
  }, 250);

  public close() {
    if (!this.config.isDesktop) {
      this.config.slideouts.forEach(_slideout => _slideout.close());
    } else {
      this.closeDropdown();
    }
  }

  public open(event: Event) {
    if (!this.config.isDesktop) {
      this.config.slideouts.forEach(_slideout => _slideout.open());
    } else {
      this.openDropdown(event);
      accordion.load();
    }
  }
}

export default new Filters();